import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { orderDetailsAPI, tagsAPI } from 'src/app/services/apiRoutes';
import { OrderUpdateModel } from '../models/order-update';

@Injectable()
export class OrderService {
  constructor(public http: HttpClient) {}

  bulkUpdateOrder(data: OrderUpdateModel): Promise<OrderUpdateModel> {
    return this.http.put<OrderUpdateModel>(orderDetailsAPI + '/' + data.identifier + '/bulk', data).toPromise();
  }

  getTags(query: string): Observable<Array<string>> {
    return this.http.get<Array<string>>(tagsAPI + '/autocomplete?query=' + query);
  }
}
